import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import vousServices from '@src/services/vous.services';

export const getVouGroupList = createAsyncThunk(
  'admin/getVouGroupList',
  async (body, { rejectWithValue }) => {
    try {
      return await vousServices.getVouGroupList();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVouList = createAsyncThunk(
  'admin/getVouList',
  async (body, { rejectWithValue }) => {
    try {
      return await vousServices.getVouList();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  vouGroupList: [],
  vouList: [],
};

export const vousSlice = createSlice({
  name: 'admin/vous',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVouGroupList.fulfilled, (state, action) => {
      state.vouGroupList = action?.payload?.data;
    });
    builder.addCase(getVouList.fulfilled, (state, action) => {
      state.vouList = action?.payload?.data;
    });
  },
});
